import React from "react";
import { useTheme } from "react-jss";
import classnames from "classnames";
import useStyles from "./ButtonChoiceTextHighlighter.styles";
import { useMouseHover } from "../../hooks/useMouseHover";

interface Props {
    id?: string;
    type: "radio";
    label?: string;
    className?: string;
    disabled?: boolean;
    selected?: boolean;
    hasOpenEnd?: boolean;
    openEndSize?: string;
    horizontal?: boolean;
    onSelect?(): void;
    onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
    renderChoice?(): any;
}

export function ButtonChoiceTextHighlighter(props: Props) {
    const {
        id,
        label,
        type,
        className,
        hasOpenEnd,
        openEndSize,
        horizontal,
        selected,
        onSelect,
        onKeyDown,
        renderChoice,
    } = props;

    const [hover, pointerHandlers] = useMouseHover();
    const [active, setActive] = React.useState(false);

    const theme = useTheme() as any;
    const classes = useStyles({ theme, selected, hasOpenEnd, openEndSize, horizontal });

    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
            id={id}
            role={type}
            aria-checked={selected}
            aria-label={label}
            onFocus={() => setActive(true)}
            onBlur={() => setActive(false)}
            {...pointerHandlers}
            onKeyDown={onKeyDown}
            onMouseDown={(e) => {
                const div = e.target as HTMLDivElement;
                const activeElement = document.activeElement as HTMLElement;
                if (!div.contains(activeElement)) activeElement.blur();
                e.preventDefault();
                onSelect();
            }}
            className={classnames(
                classes.choiceTextHighlighter,
                ...([className] || []),
                hover && classes.choiceHoverTextHighlighter,
                active && classes.choiceActiveTextHighlighter,
                selected && classes.choiceSelectedTextHighlighter,
            )}
        >
            <div className={classes.choiceContainer}>{renderChoice()}</div>
        </div>
    );
}
